import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  const _component_pointlist = _resolveComponent("pointlist");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`formUserId${$data.formUserId}`, "mapWrap"])
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.indexdata.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.indexdata.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.indexdata.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.indexdata.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.indexdata.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.indexdata.pickey !== '']]), _withDirectives(_createElementVNode("ul", {
    class: "typeul",
    style: _normalizeStyle($data.modulestyle.type)
  }, [_createElementVNode("li", {
    style: _normalizeStyle($data.ctypeIndex === 0 ? $data.typebtn[1] : $data.typebtn[0]),
    onClick: _cache[0] || (_cache[0] = $event => $options.typeClick(_ctx.item, 0))
  }, "全部", 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      style: _normalizeStyle($data.ctypeIndex === index + 1 ? $data.typebtn[1] : $data.typebtn[0]),
      onClick: $event => $options.typeClick(item, index + 1)
    }, _toDisplayString(item.itemformdata.title), 13, _hoisted_5);
  }), 128))], 4), [[_vShow, $data.showtype === 1 && $props.typelist.length > 0]]), _createVNode(_component_mappopupv2, {
    detail: $props.detail,
    popshowflag: $data.popshowflag,
    modeltype: $data.modeltype,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "onCloseHandle"]), _withDirectives(_createVNode(_component_pointlist, {
    formoption: $data.cformoption,
    datalist: $props.plist,
    modeltype: $props.style.listStyleIndex,
    style: _normalizeStyle($data.modulestyle.list)
  }, null, 8, ["formoption", "datalist", "modeltype", "style"]), [[_vShow, $props.mapform.cTemplateScore === 1]]), _withDirectives(_createElementVNode("div", {
    class: "golist",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.golist && $options.golist(...args))
  }, [_createElementVNode("img", {
    src: $data.indexdata.golist,
    alt: ""
  }, null, 8, _hoisted_6)], 512), [[_vShow, $data.showgolist]])], 2);
}